import React, { useState } from "react";
import { useStripe } from "@stripe/react-stripe-js";

export const NACHA_MANDATE_TEXT =
  "By connecting your bank, you authorize Cinesis (operated by SkyWaze Corp) to electronically debit your account and, if necessary, electronically credit your account to correct erroneous debits. Each debit is a flat fee per booking of $50 for loads under $1,000, $100 for loads from $1,000 up to $2,500, or $150 for loads of $2,500 or more, and only when Cinesis successfully books a load on your behalf. You may revoke this authorization at any time by contacting support.";

export default function StripeAchSetup({ setupSession, truckerName, onSucceeded }) {
  const stripe = useStripe();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function handleConnect() {
    if (!stripe) return;
    setError("");
    setBusy(true);
    try {
      const result = await stripe.collectBankAccountForSetup({
        clientSecret: setupSession.client_secret,
        params: {
          payment_method_type: "us_bank_account",
          payment_method_data: {
            billing_details: { name: truckerName || "Trucker" },
          },
        },
      });
      if (result.error) {
        setError(result.error.message || "Could not connect bank.");
        setBusy(false);
        return;
      }
      const confirmed = await stripe.confirmUsBankAccountSetup(setupSession.client_secret);
      if (confirmed.error) {
        setError(confirmed.error.message || "Setup failed.");
        setBusy(false);
        return;
      }
      onSucceeded();
    } catch (e) {
      setError(e?.message || "Something went wrong.");
      setBusy(false);
    }
  }

  return (
    <div className="w-full max-w-[480px] bg-white rounded-2xl shadow-md p-7">
      <h1 className="text-[22px] font-bold tracking-tight text-slate-900 mb-1.5">
        Connect your bank
      </h1>
      <p className="text-sm text-slate-500 mb-4">
        Securely connect via Stripe — we never see your bank credentials.
      </p>
      <div className="bg-slate-50 border border-slate-200 rounded-xl px-4 py-3.5 text-xs leading-relaxed text-slate-600 mb-5">
        {NACHA_MANDATE_TEXT}
      </div>
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg px-3.5 py-2.5 text-sm mb-3 leading-snug">
          {error}
        </div>
      )}
      <button
        type="button"
        onClick={handleConnect}
        disabled={busy || !stripe}
        className="w-full !shadow-none !bg-indigo-600 hover:!bg-indigo-700 !text-white !border-0 !rounded-xl !px-4 !py-3.5 !text-[15px] !font-semibold disabled:opacity-55 disabled:cursor-not-allowed"
      >
        {busy ? "Connecting…" : "Authorize and connect bank"}
      </button>
    </div>
  );
}
